import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class MailHistory {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  emailSubject!: string;
  @IsString()
  @Expose()
  userName!: string;
  @IsString()
  @Expose()
  sendDate!: string;
  @IsString()
  @Expose()
  to!: string;
  @IsString()
  @Expose()
  cc!: string;
  @IsNumber()
  @Expose()
  recordStampId!: number;
  @IsString()
  @Expose()
  messageId!: string;
}

export class MailHistoryResponse extends GenericTableResponse<MailHistory> {
  @Expose()
  @IsArray()
  @Type(() => MailHistory)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<MailHistory>;
}
